import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';

const OrderHistoryView = ({ reactTableData, isNoRecordFound, isTotalCount, isPageSize, isTotalPages }) => {
  const [rows, setRows] = useState([]);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (reactTableData && reactTableData.tableRowsData) {
      setRows(reactTableData.tableRowsData);
    } else {
      setRows([]);
    }
  }, [reactTableData]);


  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: false,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search in results by Order No., ERP No., Area...',
  };

  if (isNoRecordFound || !rows || rows.length === 0) {
    return null;
  }

  return (
    <div className="order-history-table-container p-3">
      <ReactTableBase
        name={t('instution_type.view.name_map')}
        key={'searchable'}
        columns={reactTableData.tableHeaderData}
        data={rows}
        tableConfig={tableConfig}
        isTotalCount={isTotalCount}
        isPageSize={isPageSize}
        isTotalPages={isTotalPages}
      />
    </div>
  );
};

OrderHistoryView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }),
  isNoRecordFound: PropTypes.bool,
};

export default OrderHistoryView;
